/* eslint-disable react/prop-types */
import React from 'react';
import configureStore, { Router, Provider, browserHistory } from '@clearscore/redux.store';
import { selectors as marketSelectors } from '@clearscore/redux.market';
import { I18nProvider, I18n } from '@lingui/react';

const isFunction = (config) => typeof config === 'function';

const ProviderWithI18n = ({ store, i18nProps, history, children, ...props }) => (
    <Provider store={store} {...props}>
        <I18nProvider {...i18nProps}>
            <Router history={history}>{children}</Router>
        </I18nProvider>
    </Provider>
);

const ProviderWithoutI18n = ({ store, history, children, ...props }) => (
    <Provider store={store} {...props}>
        <Router history={history}>{children}</Router>
    </Provider>
);

const translate = (i18n) => i18n._.bind(i18n);

export default ({
    children,
    storeConfig,
    i18n: i18nCatalogs,
    defaultMarket,
    defaultLocale,
    basename,
    history = browserHistory(basename),
    ...props
}) => {
    const store = isFunction(storeConfig)
        ? storeConfig
        : configureStore({ ...storeConfig, defaultLocale, defaultMarket, history });
    const state = store.getState();
    const providerProps = { store, history, ...props };
    const i18nProps = i18nCatalogs
        ? {
              catalogs: i18nCatalogs,
              locales: marketSelectors.getLocales(state),
              language: defaultLocale || marketSelectors.getActiveLocale(state),
          }
        : undefined;
    const getI18nChild = () =>
        isFunction(children) ? (
            <I18n>
                {({ i18n, i18nHash }) => children({ ...providerProps, translate: translate(i18nHash || i18n) })}
            </I18n>
        ) : (
            children
        );
    const getChild = () => (isFunction(children) ? children(providerProps) : children);

    return i18nProps ? (
        <ProviderWithI18n i18nProps={i18nProps} {...providerProps}>
            {getI18nChild()}
        </ProviderWithI18n>
    ) : (
        <ProviderWithoutI18n {...providerProps}>{getChild()}</ProviderWithoutI18n>
    );
};
